import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PtsAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-pts-slot',
    templateUrl: './pts-slot.component.html',
    styleUrl: './pts-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PtsSlotComponent implements SheetSlotComponentBase {

	@Input() action!: PtsAction;
	value = null;

	constructor() {
	}
}